export const initialState = {
  azubis: [],
  azubisWithAbteilungen: [],
  selectedBerufe: [],
  selectedMaerkte: [],
  selectedAusbildungsjahre: [],
  selectedAbteilungen: [],
  selectedIds: [],
  filterMyAbteilung: undefined,
  myAbteilungen: [],
  loadGetAzubisWithAbteilungen: false,
  matchingAzubiIds: [],
}

export default function filter(state = initialState) {
  return state
}
